<script lang="ts">
	import Button from "./Button.svelte";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import type { Product } from "../../../core/schema/Product.js";
	import type { Category } from "../../../core/schema/Category.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let product: Product;
	export let category: Category;
</script>

<a
	href={`/${product.urlSlug}`}
	class="group flex h-[28.188rem] w-full max-w-[20rem] flex-col md:h-[30.688rem] lg:w-[20.313rem] lg:max-w-[20.313rem]"
>
	<DynamicPicture
		image={product.primaryImage}
		alt=""
		bucket="storage"
		width={300}
		height={272}
		imgClass="w-[18.75rem] object-cover h-[17rem]"
		class="relative lg:ml-auto"
	/>
	<div class="relative z-20 flex h-full flex-col lg:flex-row">
		<div class="absolute bottom-0 right-0 block lg:left-0 lg:right-auto">
			<div
				class="bg-primary text-2xs absolute right-0 top-0 ml-auto flex h-[1.375rem] w-fit -translate-y-full items-center justify-center px-[.875rem] text-white lg:static lg:translate-y-0"
			>
				{nbspify(category.name)}
			</div>
			<div class="border-gray h-[11.25rem] w-[18.75rem] overflow-hidden border bg-white p-6 md:h-[12.5rem]">
				<h3 class="text-primary group-hover:text-tertiary mb-2 text-base font-extrabold md:text-[1.5rem]">
					{nbspify(product.name)}
				</h3>
				<p class="line-clamp-4 text-xs text-gray-400">
					{nbspify(product.perex)}
				</p>
			</div>
			<Button variant="primary" class="w-[7.5rem] lg:hidden">{nbspify("Více o produktu")}</Button>
		</div>
	</div>
	<Button variant="primary" class="hidden w-[13.75rem] lg:flex">{nbspify("Více o produktu")}</Button>
</a>
